import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AlfrescoDocumentsStoreEffects } from './effects';
import { FeatureName } from './feature';
import { alfrescoDocumentsStoreReducer } from './reducer';

@NgModule({
	imports: [
		CommonModule,
		StoreModule.forFeature(FeatureName, alfrescoDocumentsStoreReducer),
		EffectsModule.forFeature([AlfrescoDocumentsStoreEffects])
	]
})
export class AlfrescoDocumentsStoreModule {}
